import { CREATE_SOCKET, SWITCH_POST } from "../actionTypes";
import io from "socket.io-client";
import { ENDPOINT } from "../../helpers/endpoints";
const initialState = {
  socket: null
};
export default function(state = initialState, action) {
  switch (action.type) {
    case CREATE_SOCKET: {
      const { userId } = action.payload;
      const socket = io(ENDPOINT);
      socket.emit("join_notifications", userId);
      return {
        socket
      };
    }
    case SWITCH_POST : {
      if (state.socket) {
        const { postId, post, userId } = action.payload;
        if(postId) 
        state.socket.emit("leave", { post: postId});
        state.socket.emit("join", { post, userId }, error => {
          if (error) alert(error);
        });
        return { ...state };
      } else {
        return { ...state };
      }
    }

    default:
      return state;
  }
}
